import Select, { components } from 'react-select';
import { Box, Checkbox, Typography } from '@mui/material';
import IconChevDown from '../../assets/icons/IconChevDown';
import './MultiSelectCheckbox.scss';

// Custom Option with checkbox
const CustomMultiSelectOption = (props) => {
  return (
    <components.Option {...props}>
      <Box display='flex' justifyContent='space-between' alignItems='center' width='100%'>
        <Box display='flex' alignItems='center' gap={0.75} width='100%'>
          <Checkbox
            size='small'
            checked={props.isSelected}
            onChange={() => props.selectOption(props.data)}
            sx={{
              padding: 0,
              '& .MuiSvgIcon-root': { fontSize: 18 },
            }}
          />
          <Typography variant='body2' color='secondary.main' fontWeight={500} width='100%'>
            {props.label}
          </Typography>
        </Box>
        {props.data.expention !== undefined && (
          <Typography variant='body2' marginLeft='auto' color='error.main' fontWeight={500}>
            {props.data.expention} Exceptions
          </Typography>
        )}
      </Box>
    </components.Option>
  );
};

// Custom dropdown arrow
const CustomDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <IconChevDown />
    </components.DropdownIndicator>
  );
};

const MultiSelectWithCheckbox = ({ options, value, onChange, className, components, ...rest }) => {
  return (
    <Select
      className={'custom-react-select ' + (className ? ` ${className}` : '')}
      classNamePrefix='rs'
      isMulti
      options={options}
      value={value}
      onChange={onChange}
      placeholder='Please Select Activity(s)'
      closeMenuOnSelect={false}
      components={{
        Option: CustomMultiSelectOption,
        DropdownIndicator: CustomDropdownIndicator,
        ...components,
      }}
      {...rest}
    />
  );
};

export default MultiSelectWithCheckbox;
